<template>
  <header class="header">
    <div class="header__overlay" v-if="!hidden"></div>
    <nav class="header-nav">
      <div class="header-nav__beam">
        <div class="header-nav__title">
          <span class="header-nav__index header-nav__index--inline">{{actual.index}}</span>
          {{actual.label}}
        </div>
        <span class="header-nav__opener" @click="toggle">
          <span class="nav-toggle" :class="{ 'nav-toggle--active': !hidden }"><em></em></span>
          Menu
        </span>
      </div>
      <ul class="header-nav__list" :class="{ 'header-nav__list--hidden': hidden }">
        <router-link
          class="header-nav__item"
          tag="li"
          :to="item.to"
          v-for="(item, index) in navItems"
          :key="item.to"
        >
          <a v-if="item.button" class="button">{{item.label}}</a>
          <a v-else class="header-nav__link">
            <span class="header-nav__index">0{{index + 1}}.</span>
            {{item.label}}
          </a>
        </router-link>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  data() {
    return {
      hidden: true,
      navItems: [
        {
          to: '/welcome',
          name: 'Welcome',
          label: 'Welcome to Kyocera',
          button: false,
        },
        {
          to: '/intro',
          name: 'Intro',
          label: 'Product introduction',
          button: false,
        },
        {
          to: '/benefits',
          name: 'Benefits',
          label: 'Benefits',
          button: false,
        },
        {
          to: '/configurator',
          name: 'Configurator',
          label: 'Configurator',
          button: false,
        },
        {
          to: '/calculator',
          name: 'Calculator',
          label: 'Calculate savings',
          button: true,
        },
      ],
    };
  },
  mounted() {
    window.addEventListener('click', () => {
      if (!this.hidden) {
        this.hidden = true;
      }
    });
  },
  methods: {
    toggle(event) {
      event.stopPropagation();
      this.hidden = !this.hidden;
    },
  },
  computed: {
    actual() {
      let actual;
      this.navItems.forEach((item, index) => {
        if (this.$route.name === item.name) {
          actual = item;
          actual.index = `0${index + 1}.`;
        }
      });

      return actual || {
        label: 'Configurator',
        index: '04.',
      };
    },
  },
};
</script>


<style lang="scss">
@import '../styles/helpers';

.button {
  background-color: #6E3CBE;
  color: #fff;
  padding: 12px 0 0;
  height: 40px;
  width: 187px;
  flex-shrink: 0;
  display: inline-block;
  text-align: center;
  box-sizing: border-box;
  text-decoration: none;
}
.header {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: $c_grey--light;
  box-shadow: 10px 10px 10px 10px rgba(#282828, .1);

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background: rgba(#fff, .1);
    z-index: -1;
  }

  &-nav__beam {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 44px;
  }

  &-nav__title {
    font-weight: 300;
  }

  &-nav__opener {
    cursor: pointer;
    display: inline-block;
    padding: 10px 0;

    img {
      margin-right: 5px;
      transform: translateY(2px);
    }
  }

  &-nav__list {
    list-style: none;
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 60px 44px 53px 74px;
    background: #282828;
    box-sizing: border-box;
    max-height: 160px;
    transition: max-height .45s, padding .45s;
    overflow: hidden;

    &--hidden {
      max-height: 0;
      padding-bottom: 0;
      padding-top: 0;
    }
  }

  &-nav__link {
    text-decoration: none;
    color: white;
    font-weight: 300;
  }

  &-nav__index {
    display: block;
    color: #6E3CBE;
    font-weight: 500;

    &--inline {
      display: inline;
    }
  }
}

$height: 1px;
$width: 23px;
$spacing: 6px; // center to center

.nav-toggle {
  display: inline-block;
  margin: 0;
  width: $width;
  height: 2 * $spacing + $height;
  overflow: hidden;
  padding: 1px 0;
  z-index: 100;
  outline: none;
  margin-right: 5px;
  position: relative;
  transform: translateY(2px);

  em,
  &::after,
  &::before {
    background: $c_purple;
    content: '';
    display: block;
    height: $height;
    width: $width;
    position: absolute;
    transition: margin .35s, top .35s, opacity .35s, transform .35s;
    top: calc(50% - #{$height / 2});
    margin-top: 0;
    left: calc(50% - #{$width / 2});
  }

  &::after {
    margin-top: -$spacing;
  }

  &::before {
    margin-top: $spacing;
  }

  &--active {

    &::after {
      margin: 0;
      transform: rotateZ(-45deg);
    }

    &::before {
      margin: 0;
      transform: rotateZ(45deg);
    }

    em {
      opacity: 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/AppHeader.vue